import { apolloClient } from '../../apollo';
import { FeatureFlagMutations } from '../graphql/feature-flag.mutations';
import type { FeatureFlag } from '../types/feature-flag';

export class FeatureFlagService {
  static async evaluateFeatureFlag(flag: FeatureFlag): Promise<boolean> {
    const {
      data: { evaluateFeatureFlag },
    } = await apolloClient.mutate({
      mutation: FeatureFlagMutations.evaluateFeatureFlag,
      variables: { flag },
    });
    return evaluateFeatureFlag;
  }
}
